import { Avatar, Box, Card, Stack } from "@mui/material";
import { H2, H6 } from "components/Typography";

const MembersBusinessDoneCard = ({ businessDone = 0 }) => {
  // Format the number to Indian currency format with commas
  const formatIndianCurrency = (amount) => {
    const formatter = new Intl.NumberFormat('en-IN', {
      maximumFractionDigits: 0
    });
    return formatter.format(amount);
  };

  return (
    <Card sx={{ padding: 3, height: "100%" }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Box flex={1}>
          <H6>Business Done</H6>
          <H2 color="primary.main">₹ {formatIndianCurrency(businessDone)}</H2>
        </Box>

        <Avatar 
          src="/static/illustration/crm-lead.svg" 
          alt="Lead Converted" 
          sx={{
            width: "auto",
            height: "auto",
            borderRadius: "0%"
          }} 
        />
      </Stack>
    </Card>
  );
};

export default MembersBusinessDoneCard;